import { createSlice } from "@reduxjs/toolkit";
import { ISelectOption } from "src/@types/form";
import { getPricesReducer } from "./reducers";
import { PRICES_SLICE_NAME } from "./actions";

export interface IPricesState {
  isLoading: boolean;
  data: ISelectOption[];
}

const initialState: IPricesState = {
  isLoading: false,
  data: [],
};

export const { reducer: prices } = createSlice({
  name: PRICES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getPricesReducer(builder);
  },
});
